<template>
  <div class="page-container has-action">
    <van-nav-bar
      class="payment-navbar"
      title="充值"
      right-text="限额说明"
      fixed
      left-arrow
      @click-left="goableBack()"
      @click-right="showQuotaLimitPopu" />
    <div class="recharge">
      <div class="block">
        <div class="fs-18">充值金额</div>
        <van-field
          class="tian-amount mt-10"
          type="number"
          v-model="payForm.tradeAmount"
          @blur="setAmountInMin"
          @input="onInput"
          :placeholder="rechargeTxt">
          <div slot="left-icon">￥</div>
        </van-field>
      </div>

      <div class="block">
        <van-field
          v-model="bankCard"
          readonly
          clearable
          input-align="right"
          label="银行卡"
          placeholder="请选择银行卡"
          @click="bankPicker.show = true"
          right-icon="arrow-down" />
      </div>
    </div>
    <div class="page-action">
      <van-button
        :disabled="submitDisabled"
        class="payment-next-step"
        @click="onClickNext"
        type="danger"
        size="large"
        >确定</van-button
      >
    </div>
    <van-popup v-model="bankPicker.show" position="bottom">
      <van-picker
        show-toolbar
        value-key="tailTag"
        :columns="bankPicker.columns"
        :loading="bankPicker.loading"
        @cancel="bankPicker.show = false"
        @confirm="confirmBankPicker" />
    </van-popup>

    <bl-eft
      v-model="eftShow"
      :payType="payType"
      title="金额超出上限 请使用线下转账"></bl-eft>

    <!-- 限额列表 -->
    <van-popup
      class="limit-list"
      v-model="bankCeiling.show"
      closeable
      close-icon="close"
      close-icon-position="top-right"
      position="bottom"
      round>
      <div style="margin-top: 25px; margin-bottom: 5px">
        <van-cell v-for="(item, inde) in bankCeiling.columns" :key="inde">
          <van-cell :title="item.bankName" :value="item.quota" />
        </van-cell>
      </div>
    </van-popup>
  </div>
</template>

<script>
import * as PayApi from "@/api/pay"
import BlEft from "@/components/bl-eft"
import * as CustApi from "@/api/cust"
import { mapGetters } from "vuex"
import "./idx.less"
import {
  NavBar,
  Button,
  Radio,
  Toast,
  Field,
  Checkbox,
  Popup,
  Picker,
  Icon
} from "vant"

export default {
  name: "Recharge1",
  components: {
    BlEft,
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [Toast.name]: Toast,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Icon.name]: Icon
  },

  data() {
    return {
      bankCard: "",
      rechargeTxt: "充值金额 1 元起",
      bankCeiling: {
        show: false,
        loading: false,
        columns: []
      },
      //  用户选择银行卡
      bankPicker: {
        show: false,
        loading: false,
        columns: []
      },

      payForm: {
        tradeAmount: "",
        bindCardId: "", // 用户选择的银行卡的银行id
        terminal: "H5"
      },
      payType: {},
      eftShow: false
    }
  },
  computed: {
    ...mapGetters(["channel"]),
    submitDisabled: function () {
      if (this.channel && ["bl", "ht"].includes(this.channel.toLowerCase())) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    "payForm.tradeAmount": function (val, old) {
      /*
      if (val.length > 0) {
        val = val.replace(/[^\d.]/g, "") //清除非数字和小数点的字符
        val = val.replace(/\.{2,}/g, ".") //清除第二个小数点
        val = val.replace(/^\./g, "") //验证第一个字符是数字而不是字符
        val = val.replace(".", "$#$")
        val = val.replace("/./g", "")
        val = val.replace("$#$", ".")
        val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3") //保留两位小数
        // value = val.indexOf(".") > 0 ? value.split(".")[0].substring(0,7)+'.'+value.split(".")[1]//保留7位正整数
        // this.payForm.tradeAmount = new Decimal(val).mul(100).toFixed()
        // this.payForm.tradeAmount = val
      }*/
      if (this.payForm.tradeAmount > 0) {
        this.payForm.tradeAmount = parseInt(val)
      }
    }
  },

  beforeMount() {
    this.getBankList()
    this.getBankQuotaLimitationList()
    PayApi.paytype()
      .then((data) => {
        this.payType = data
      })
      .catch((e) => {
        Toast(e.msg || e.message)
      })
  },

  methods: {
    showQuotaLimitPopu() {
      this.bankCeiling.show = true
    },
    onInput(value) {
      if (value == 0) {
        this.payForm.tradeAmount = ""
      }
    },
    // 失去焦点，如果金额小于最小起购金额。自动填充最小起购金额
    setAmountInMin() {
      let amount = Number(this.payForm.tradeAmount)
      if (amount < 1) {
        Toast(this.rechargeTxt)
        this.payForm.tradeAmount = 1
        return
      }
    },
    getBankQuotaLimitationList() {
      return PayApi.banklist()
        .then((data) => {
          this.bankCeiling.columns = data
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    getBankList() {
      this.bankPicker.loading = true
      CustApi.listBindCard()
        .then((data) => {
          this.bankPicker.columns = data
          this.bankPicker.loading = false
          if (data && data.length) {
            this.bankCard = data[0].tailTag
            this.payForm.bindCardId = data[0].id
          }
        })
        .catch((e) => {
          this.bankPicker.loading = false
          Toast(e.msg || e.message)
        })
    },

    onClickNext() {
      if (!this.payForm.tradeAmount) {
        Toast("请输入充值金额!")
        return
      }

      if (!this.payForm.bindCardId) {
        Toast("请先选择银行卡!")
        return
      }
      this._showLoading()

      PayApi.recharge(this.payForm)
        .then((data) => {
          this._dismissLoading()
          if (!data) {
            Toast("服务器繁忙, 请稍后再试")
            return
          }
          location.href = data
        })
        .catch((e) => {
          this._dismissLoading()
          if (e.code == 2006) {
            //如果在线支付功能没有开启，就跳转到离线充值页面
            this.$toast({
              message: "本次充值超过银行限额，请使用线下转账充值",
              onClose: () => {
                this.$router.push({
                  name: "recharge_offline",
                  query: { redirect: this.$route.fullPath }
                })
              }
            })
            return
          } else {
            Toast(e.msg || e.message)
          }
        })
    },

    // 确认选择银行卡
    confirmBankPicker(value) {
      this.bankCard = value.tailTag
      this.payForm.bindCardId = value.id
      this.bankPicker.show = false
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .tian-amount {
  .van-field__left-icon {
    font-weight: 600;
  }
  .van-field__left-icon,
  .van-field__control {
    font-size: 32px;
    line-height: 36px;
  }
}

.limit-list {
  padding-top: 10px;
  max-height: 80%;
  .van-cell {
    padding: 0rem 0.2rem;
  }

  .van-cell__value {
    font-size: 12px;
    flex: 3;
  }

  .van-cell__title {
    flex: 1;
  }
}
</style>
